import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@sainsburys-tech/bolt'
import { openAccordion } from '../../../helpers/openAccordion'
import { pushEventAndTrack } from '../../../helpers/taggingSerializer'

import * as Styled from './Dimension.styles'

const Dimension = ({ dimension }) => {
  const formattedDimension = dimension?.replace(/,/g, ' x')

  // TODO: Add an event handler to open dimensions accordion for <Button> element

  return (
    <Styled.DimensionWrapper>
      <Styled.IconWrapper width={24} height={24} data-test='icon' />
      {formattedDimension && (
        <Styled.DimensionText data-test='dimension-text'>{formattedDimension}</Styled.DimensionText>
      )}
      <Button
        data-test='view-full-dimensions'
        kind='link'
        onClick={() => {
          openAccordion('#habitat-dimensions')
          pushEventAndTrack({
            eventInfo: {
              eventName: 'pdp_mtoCtaClick',
              eventAction: 'View full dimensions'
            }
          })
        }}
      >
        View full dimensions
      </Button>
    </Styled.DimensionWrapper>
  )
}

Dimension.propTypes = {
  dimension: PropTypes.string
}

export default Dimension
